import RestClient from '../../../../api/axiosInterceptor';
import { hospitalVerificationActions, hospitalResendVerificationActions } from '../../../actions/user/hospital/Account/verification';
import { toast } from 'react-toastify';

/**
 * Helper function to create asynchronous actions for Redux.
 * @param {string} actionType - The action type to dispatch.
 * @param {function} apiCall - The API call function to make the request.
 */
const createAsyncAction = (actionType, apiCall) => async (dispatch) => {
  try {
    // Dispatch the request action before making the API call
    dispatch({ type: actionType.REQUEST });

    // Make the API call and wait for the response
    const response = await apiCall();

    // Dispatch the success action with the response data
    dispatch({
      type: actionType.SUCCESS,
      payload: response.data
    });
    toast.success(response.data.message, { position: 'top-center' });
  } catch (error) {
    const errorMessage = error.response?.data?.message;

    dispatch({
      type: actionType.FAILURE,
      error: errorMessage
    });
    toast.error(errorMessage, { position: 'top-center' });
  }
};

export const hospitalVerifyEmail = (token) =>
  createAsyncAction(
    hospitalVerificationActions.EMAIL,
    () => RestClient.get(`/hospital/verification/${token}`)
  );

export const hospitalResendVerificationEmail = (email) =>
  createAsyncAction(
    hospitalResendVerificationActions.RESEND_VERIFICATION_EMAIL,
    () => RestClient.post('/hospital/resend-verification', { email })
  );
